import { commitMutation, graphql } from 'react-relay';
import environment from 'api/environment';
import { GraphError } from 'types/general';
import { mutations_UpdateCompanyMutationResponse } from './__generated__/mutations_UpdateCompanyMutation.graphql';

const updateCompanyMutation = graphql`
  mutation mutations_UpdateCompanyMutation(
    $uuid: UUID!
    $name: String
    $contactEmail: String
    $addressLine1: String
    $addressLine2: String
    $county: String
    $postCode: String
    $logoToken: String
  ) {
    updateCompany(
      input: {
        uuid: $uuid
        companyName: $name
        contactEmail: $contactEmail
        addressLine1: $addressLine1
        addressLine2: $addressLine2
        county: $county
        postCode: $postCode
        logoToken: $logoToken
      }
    ) {
      uuid
      name
      contactEmail
      logoURL
      address {
        addressLine1
        addressLine2
        county
        postCode
      }
    }
  }
`;

export const UpdateCompany = (
  company: {
    uuid: string;
    name: string;
    contactEmail: string;
    addressLine1: string;
    addressLine2: string;
    county: string;
    postCode: string;
    logoToken?: string;
  },
  errorCallback: (err: string) => void,
  successCallback: (response: mutations_UpdateCompanyMutationResponse) => void
) => {
  const variables = {
    uuid: company.uuid,
    name: company.name,
    contactEmail: company.contactEmail,
    addressLine1: company.addressLine1,
    addressLine2: company.addressLine2,
    county: company.county,
    postCode: company.postCode,
    logoToken: company.logoToken
  };
  commitMutation(environment, {
    mutation: updateCompanyMutation,
    variables,
    onCompleted: (
      response: mutations_UpdateCompanyMutationResponse,
      errors: GraphError[]
    ) => {
      if (errors) {
        errorCallback(`${errors[0]?.extensions?.message}`);
        return;
      }
      successCallback(response);
    }
  });
};
